// import React from "react";
// import axios from "axios";
// import { useAuth } from "./AuthContext";
// import "./SubscriptionSection.css";

// export default function SubscriptionSection() {
//   const { user } = useAuth();

//   const handleUpgrade = async (planCode) => {
//     if (!user) {
//       alert("Please log in to upgrade.");
//       return;
//     }

//     try {
//       // FIX: Get the token so the server knows who you are
//       // Check if your token is stored as "token" or "authToken" in localStorage
//       const token = localStorage.getItem("token"); 

//       const config = {
//         headers: { 
//           Authorization: `Bearer ${token}` 
//         }
//       };

//       // 1. Tell Backend to create an invoice (with the token attached!)
//       const res = await axios.post(
//         '/api/billing/attempts', 
//         {
//           planCode: planCode,
//           userId: user.id || user._id // Handle both ID formats just in case
//         }, 
//         config // <--- This is the key fix that prevents the 500 Error
//       );

//       // 2. Backend sends back the Bank URL with the invoice number attached
//       const { redirectUrl } = res.data;

//       if (redirectUrl) {
//         // 3. Go to the Bank
//         // Using window.location.href redirects the current tab (standard for payments)
//         window.location.href = redirectUrl;
//       } else {
//         alert("Error setting up payment. Please try again.");
//       }

//     } catch (err) {
//       console.error("Payment Error:", err);
//       // Optional: Check if it's a 401 (Unauthorized) to give a better error
//       if (err.response && err.response.status === 401) {
//           alert("Your session may have expired. Please log out and log back in.");
//       } else {
//           alert("Failed to start payment session. Please try again.");
//       }
//     }
//   };

//   return (
//     <section className="sub-wrap">
//       <div className="sub-inner">
//         <div className="sub-header">
//           <h3>Unlock more with JobFAX</h3>
//           <p>
//             Upgrade for deeper verification, saved history, and higher usage limits.
//           </p>
//         </div>

//         <div className="sub-grid">
//           {/* General Plan */}
//           <div className="sub-card">
//             <div className="sub-title">General</div>
//             <div className="sub-price">$5</div>
//             <div className="sub-desc">For individual job seekers</div>

//             <ul className="sub-list">
//               <li>Core PREP checks</li>
//               <li>Standard report output</li>
//               <li>Limit: 20 reports/week</li>
//             </ul>

//             <button className="sub-btn primary" onClick={() => handleUpgrade('weekly_basic_5')}>
//               Upgrade to General
//             </button>
//           </div>

//           {/* Enterprise Plan */}
//           <div className="sub-card highlight">
//             <div className="sub-title">Enterprise</div>
//             <div className="sub-price">$20</div>
//             <div className="sub-desc">For teams & heavier usage</div>

//             <ul className="sub-list">
//               <li>Everything in General</li>
//               <li><strong>Unlimited</strong> report volume</li>
//               <li>Priority analysis</li>
//             </ul>

//             <button className="sub-btn" onClick={() => handleUpgrade('weekly_pro_20')}>
//               Upgrade to Enterprise
//             </button>
//           </div>
//         </div>

//         <div className="sub-footnote">
//           Payments are processed securely via Converge. Your subscription activates automatically after payment.
//         </div>
//       </div>
//     </section>
//   );
// }












// import React from "react";
// import "./SubscriptionSection.css";

// export default function SubscriptionSection() {
//   // Put your real Converge links here (or use env vars below)
//   const GENERAL_SUBSCRIPTION_URL =
//   "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=QxbDD%2FrbRhy62%2BeAXqLYiwAAAZu%2BfHB%2F";

//     const ENTERPRISE_SUBSCRIPTION_URL =
//   "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=qQduM7AcSCGmvXZnvuY0oQAAAZu%2BfnD%2F";


//   const openPay = (url) => {
//     if (!url) {
//       alert("Billing link not configured yet.");
//       return;
//     }
//     window.open(url, "_blank", "noopener,noreferrer");
//   };

//   return (
//     <section className="sub-wrap">
//       <div className="sub-inner">
//         <div className="sub-header">
//           <h3>Unlock more with JobFAX</h3>
//           <p>
//             Upgrade for deeper verification, saved history, and higher usage limits.
//           </p>
//         </div>

//         <div className="sub-grid">
//           <div className="sub-card">
//             <div className="sub-title">General</div>
//             <div className="sub-price">$5</div>
//             <div className="sub-desc">For individual job seekers</div>

//             <ul className="sub-list">
//               <li>Core PREP checks</li>
//               <li>Standard report output</li>
//               <li>Higher usage limits</li>
//             </ul>

//             <button className="sub-btn primary" onClick={() => openPay(GENERAL_SUBSCRIPTION_URL)}>
//               Upgrade to General
//             </button>
//           </div>

//           <div className="sub-card highlight">
//             <div className="sub-title">Enterprise</div>
//             <div className="sub-price">$20</div>
//             <div className="sub-desc">For teams & heavier usage</div>

//             <ul className="sub-list">
//               <li>Everything in General</li>
//               <li>Unlimited / higher report volume</li>
//               <li>Priority analysis + audit-friendly history</li>
//             </ul>

//             <button className="sub-btn" onClick={() => openPay(ENTERPRISE_SUBSCRIPTION_URL)}>
//               Upgrade to Enterprise
//             </button>
//           </div>
//         </div>

//         <div className="sub-footnote">
//           Payments are processed securely via Converge. Your subscription activates after confirmation.
//         </div>
//       </div>
//     </section>
//   );
// }


import React from "react";
import { useAuth } from "./AuthContext";
import "./SubscriptionSection.css";

export default function SubscriptionSection() {
  const { user } = useAuth();

  // const handleUpgrade = (planCode) => {
  //   if (!user) {
  //     alert("Please log in to upgrade.");
  //     return;
  //   }

  //   // 🛑 Pointing to live domain instead of localhost/ngrok
  //   const BACKEND_URL = "https://api.job-fax.com"; 

  //   // 1. Pick the correct Converge link based on the button clicked
  //   let TOKEN_URL = "";
  //   if (planCode === 'BASIC') {
  //     // $5
  //     TOKEN_URL = "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=QxbDD%2FrbRhy62%2BeAXqLYiwAAAZu%2BfHB%2F"; 
  //   } else if (planCode === 'PRO') {
  //     // $20
  //     TOKEN_URL = "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=qQduM7AcSCGmvXZnvuY0oQAAAZu%2BfnD%2F";
  //   }

  //   // Combine the User ID and the Plan Code (e.g., "123_PRO")
  //   const userId = user.id || user._id || "UNKNOWN";
  //   const trackingId = `${userId}_${planCode}`; 

  //   console.log(`🚀 Redirecting to Converge for User: ${userId} | Plan: ${planCode}`);

  //   // 3. Send them to the bank and tell Converge to ping the LIVE backend webhook
  //   const webhookUrl = `${BACKEND_URL}/api/billing/converge/webhook`;
  //   const finalUrl = `${TOKEN_URL}&ssl_customer_code=${trackingId}&ssl_invoice_number=${Date.now()}&ssl_result_url=${webhookUrl}`;

  //   window.location.href = finalUrl;
  // };

  const handleUpgrade = (planCode) => {
    if (!user) {
      alert("Please log in to upgrade.");
      return;
    }

    const BACKEND_URL = "https://api.job-fax.com"; 

    let TOKEN_URL = "";
    if (planCode === 'BASIC') {
      TOKEN_URL = "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=QxbDD%2FrbRhy62%2BeAXqLYiwAAAZu%2BfHB%2F"; 
    } else if (planCode === 'PRO') {
      TOKEN_URL = "https://www.convergepay.com/hosted-payments?ssl_txn_auth_token=qQduM7AcSCGmvXZnvuY0oQAAAZu%2BfnD%2F";
    }

    const userId = user.id || user._id || "UNKNOWN";
    // We use the user's email for the description to match the XML query
    const userEmail = user.email; 
    const trackingId = `${userId}_${planCode}`; 

    const webhookUrl = `${BACKEND_URL}/api/billing/converge/webhook`;
    const finalUrl = `${TOKEN_URL}&ssl_customer_code=${trackingId}&ssl_invoice_number=${Date.now()}&ssl_description=${encodeURIComponent(userEmail)}&ssl_result_url=${encodeURIComponent(webhookUrl)}`;

    window.location.href = finalUrl;
  };

  return (
    <div className="sub-wrap">
      <div className="sub-inner">
        <div className="sub-header">
          <h3>Upgrade Your Account</h3>
          <p>Choose the plan that fits your job search needs.</p>
        </div>
        
        <div className="sub-grid">
          {/* THE $5 BASIC CARD */}
          <div className="sub-card">
            <div className="sub-title">Weekly Basic</div>
            <div className="sub-price">$5</div>
            <p className="text-sm mt-2 mb-4 text-gray-400">Limited weekly reports</p>
            <button 
              onClick={() => handleUpgrade('BASIC')}
              className="auth-button"
              style={{ width: '100%', backgroundColor: '#4b5563' }}
            >
              Get Basic
            </button>
          </div>

          {/* THE $20 PRO CARD */}
          <div className="sub-card highlight">
            <div className="sub-title">Weekly Pro</div>
            <div className="sub-price">$20</div>
            <p className="text-sm mt-2 mb-4 text-gray-200">Unlimited access & deep scans</p>
            <button 
              onClick={() => handleUpgrade('PRO')}
              className="auth-button"
              style={{ width: '100%' }}
            >
              Get Pro
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}